import styled from 'styled-components';

import { useBreakpoint } from '@hivebrite/design-system/Theme';

import { Wrapper } from 'hb-builder/components/common/Wrapper/WrapperRender';
import { getWrapperHeadlineStyle } from 'hb-builder/components/UIComponents/page/single/Headline/style';
import { useRendererContext } from 'hb-builder/hooks';
import { styles } from 'hb-react/shared/components/DesignSystem/QuillEditor/ContentEditable';

export const HeadlineWrapper = ({ attributes, children, componentType }) => {
  const breakpoint = useBreakpoint();
  const { isMobilePreview } = useRendererContext();

  return (
    // @ts-expect-error untyped
    <Wrapper
      attributes={attributes}
      componentType={componentType}
      dataTestId="builder-component-headline"
      isMobilePreview={isMobilePreview}
      style={getWrapperHeadlineStyle({
        attributes,
        breakpoint,
      })}
    >
      <StyledHtml
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: children }}
      />
    </Wrapper>
  );
};

const StyledHtml = styled.div`
  width: 100%;
  ${styles({
    isHeadline: true,
    defaultLinkColor: false,
    disableLinks: false,
    underlineLinks: true,
  })}
`;
